import React, { useEffect, useState } from 'react';
import { Wordmark } from '../../ui/index.js';
import { TERMS, TERMS_VERSION, fillTerms } from './terms.js';
import './privacy.css';

// The sections alone, for the page and for the onboarding dialog (same pattern as PrivacyNotice).
export function TermsBody({ language = 'tr', controller, headingLevel = 2 }) {
  const t = TERMS[language === 'en' ? 'en' : 'tr'], H = `h${headingLevel}`;
  return <>{t.sections.map(([title, items], i) => <section key={title} className="terms-section" aria-labelledby={`terms-${headingLevel}-${i}`}>
    <H id={`terms-${headingLevel}-${i}`}>{i + 1}. {title}</H>
    {items.length > 1 ? <ul>{items.map(x => <li key={x}>{fillTerms(x, controller)}</li>)}</ul> : <p>{fillTerms(items[0], controller)}</p>}
  </section>)}</>;
}

// /kosullar (eksik listesi #17): kullanım koşulları; düzen /gizlilik ile aynı.
export function TermsPage() {
  const language = new URLSearchParams(location.search).get('lang') === 'en' ? 'en' : 'tr', en = language === 'en', t = TERMS[language];
  const [config, setConfig] = useState(null);
  useEffect(() => { document.documentElement.lang = language; document.title = `BiSponsor · ${t.title}`; fetch('/api/public/config').then(r => r.json()).then(setConfig).catch(() => setConfig({})); }, [language]);
  return <main className="privacy-page">
    <a href="/" className="privacy-home" aria-label="BiSponsor"><Wordmark /></a>
    <h1>{t.title}</h1>
    <p className="privacy-meta">{en ? 'Version' : 'Sürüm'} {TERMS_VERSION} · {t.effective} · <a href={en ? '/kosullar' : '/kosullar?lang=en'}>{en ? 'Türkçe' : 'English'}</a></p>
    {t.note && <p className="privacy-meta">{t.note}</p>}
    <TermsBody language={language} controller={config?.controller} />
    <p className="privacy-meta"><a href={en ? '/gizlilik?lang=en' : '/gizlilik'}>{en ? 'Privacy notice' : 'Aydınlatma metni'}</a> · <a href="/panel">{en ? 'Sign in' : 'Giriş yap'}</a> · <a href="/">{en ? 'Back to BiSponsor' : "BiSponsor'a dön"}</a></p>
  </main>;
}
